module.exports = __webpack_public_path__ + "img/code1.a6b5db61.png";